const shouldSkip = (isGoingForward, hasChildren, children) =>
  !hasChildren || (isGoingForward && children.length > 0);

export default shouldSkip;
